import { Storybook } from "@tento-ui/ui/storybook";
import { TurnPrompt } from "./prompt";

export class TurnPromptStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · prompt";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Short",
        render: () =>
          TurnPrompt.makeWith({
            text: "let's check that it's back working again",
          }),
      },
      {
        title: "Long — wraps, still narrower than the column",
        render: () =>
          TurnPrompt.makeWith({
            text:
              "i'd like to improve our tsh default shell ui such that we sticky the user's prompt to the tab of the shell (capped to 2 lines), using a long horizontal divider as separation",
          }),
      },
      {
        title: "Multi-line — newlines survive",
        render: () =>
          TurnPrompt.makeWith({
            text: "run these in order:\n  1. cargo fmt\n  2. cargo test -p tsh",
          }),
      },
      {
        title: "Unbroken token — wraps rather than overflowing",
        render: () =>
          TurnPrompt.makeWith({
            text:
              "/Users/james/workspace/tento/tento-node-registry/tento-spool.node/html/routes/index.root.ts",
          }),
      },
    ];
  }
}
